/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function showVariantImage(variantSku) {
      document.querySelectorAll('.product-single__gallery--equal .product-single__media-slide').forEach(function(item) {
          item.style.display = 'none';
      });
      document.querySelectorAll('.product-single__gallery--equal .product-single__media-slide[data-variant-id*="'+ variantSku +'"]').forEach(function(item) {
          item.style.display = 'block';
      });
   }
  document.querySelectorAll('.swatch__label').forEach(function(label) {
    label.addEventListener('click', function() {
        var selectedVariantSku = this.getAttribute('data-swatch');
        document.querySelector('.tni_current_switcher.tni_swatches_label').innerHTML = selectedVariantSku;

        // Get the selected variant value
        var tniSelectedVariant = document.querySelector('.tni_current_selected_variant').value;
    });
  });

  // Handle radio label click
  document.querySelectorAll('.radio__label').forEach(function(label) {
      label.addEventListener('click', function() {
          var selectedVariantSku = this.previousElementSibling.value; // Gets the sibling input radio value
          selectedVariantSku = selectedVariantSku.replace(/"/g, ''); // Replace quotes with empty string
  
          // Update the HTML with the selected variant SKU
          document.querySelector('.tni_current_switcher:not(.tni_swatches_label)').innerHTML = selectedVariantSku;
      });
  });

  console.log("spvirani this is for test");
  console.log(document.querySelector('.swatch__button .swatch__input:checked') ? document.querySelector('.swatch__button .swatch__input:checked').value : '');
  
  // Get the current active variant
  var tniCurrentActiveVariant = document.querySelector('.swatch__button .swatch__input:checked');
  if (tniCurrentActiveVariant) {
      var checkisMainProduct = tniCurrentActiveVariant.getAttribute('data-product-tag');
      document.querySelector('.tni_current_switcher.tni_swatches_label').innerHTML = tniCurrentActiveVariant.value;
  }
  
  // Get the length of the current active variant
  var tniCurrentlenthActiveVariant = document.querySelector('.radio__button .radio__input:checked');
  if (tniCurrentlenthActiveVariant) {
      document.querySelector('.tni_current_switcher:not(.tni_swatches_label)').innerHTML = tniCurrentlenthActiveVariant.value;
  }
  
  // Check if a variant is selected and show the corresponding image

  var tniwindowWidth = window.innerWidth;
  if(tniwindowWidth > 1200)
  {  
    var tniSelectedVariant = document.querySelector('.tni_current_selected_variant').value;
    if (tniSelectedVariant) {
        showVariantImage(tniSelectedVariant);
    }
  }
 



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
